import { render, staticRenderFns } from "./shinetop.vue?vue&type=template&id=0560dda2&scoped=true&"
import script from "./shinetop.vue?vue&type=script&lang=js&"
export * from "./shinetop.vue?vue&type=script&lang=js&"
import style0 from "./shinetop.vue?vue&type=style&index=0&id=0560dda2&scoped=true&lang=css&"
import style1 from "./shinetop.vue?vue&type=style&index=1&id=0560dda2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0560dda2",
  null
  
)

export default component.exports